import React from 'react'
import { Link } from 'react-router-dom'
import Icons from '../Icons'
import styles from './style.module.scss'

export function IconButton({icon, label, path, type, name, onClick}) {
  if ( !icon )
    throw("Error: Icon button cannot be rendered without an icon ref. (at src/_components/Buttons/IconButton.jsx:4)")

  const IconComponent = (icon.indexOf('Icon') !== -1 ) ? Icons[icon] : Icons[`${icon}Icon`]
  
  if ( !IconComponent )
    throw("Error: Icon type not found. (at src/_components/Buttons/IconButton.jsx:7)")

  return (
    <div className={styles["icobtn__wrapper"]}>
      {
        !path ?
          <button type={!type ? "button" : type} onClick={onClick} name={name}>
            <IconComponent />
          </button>
      : <Link to={path}>
          <IconComponent />
        </Link>
      }
      
      { label ? <span>{label}</span> : null }
    </div>
  )
}